if (!customElements.get('zen-card-slider')) {
  customElements.define(
    'zen-card-slider',
    class ZenCardSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.zen-card-slider__track');
        if (!this.track) return;
        this.slides = Array.from(this.querySelectorAll('.zen-card-slider__slide-wrap'));
        if (this.slides.length < 2) return;

        this.currentIndex = 0;
        this.prevBtn = this.querySelector('.zen-card-slider__btn--prev');
        this.nextBtn = this.querySelector('.zen-card-slider__btn--next');

        const stopAll = (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
        };

        let lockUntil = 0;
        const handlePrev = (e) => {
          stopAll(e);
          const now = Date.now();
          if (now < lockUntil) return;
          lockUntil = now + 350;
          this.goTo(this.currentIndex - 1);
        };
        const handleNext = (e) => {
          stopAll(e);
          const now = Date.now();
          if (now < lockUntil) return;
          lockUntil = now + 350;
          this.goTo(this.currentIndex + 1);
        };

        this.prevBtn?.addEventListener('click', handlePrev);
        this.nextBtn?.addEventListener('click', handleNext);

        const stopBubble = (e) => {
          e.stopPropagation();
          if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
        };

        ['mousedown', 'pointerdown'].forEach((ev) => {
          this.prevBtn?.addEventListener(ev, stopBubble);
          this.nextBtn?.addEventListener(ev, stopBubble);
        });

        this.track.addEventListener('scroll', () => {
          this.syncIndexFromScroll();
        }, { passive: true });

        requestAnimationFrame(() => this.updateButtons());
      }

      goTo(index) {
        if (index < 0 || index >= this.slides.length) return;
        this.currentIndex = index;
        const targetLeft = this.slides[index].offsetLeft;
        try {
          this.track.scrollTo({ left: targetLeft, behavior: 'smooth' });
        } catch (e) {
          this.track.scrollLeft = targetLeft;
        }
        this.updateButtons();
      }

      syncIndexFromScroll() {
        const slideWidth = this.slides[0].getBoundingClientRect().width;
        if (slideWidth > 0) {
          this.currentIndex = Math.round(this.track.scrollLeft / slideWidth);
        }
        this.updateButtons();
      }

      updateButtons() {
        if (!this.prevBtn || !this.nextBtn) return;
        this.prevBtn.toggleAttribute('disabled', this.currentIndex <= 0);
        this.nextBtn.toggleAttribute('disabled', this.currentIndex >= this.slides.length - 1);
      }
    }
  );
}
